import { AppModal } from '../../../../../generic/ui/Modal'
import ModalKnisaTitle from './Components/Modal/ModalKnisaTitle'
import ModalKnisaAddProduct from './Components/Modal/ModalKnisaAddProduct'
import DivideModal from '../../miun/modal/DivideModal'
import EntryPalletsModal from '../../../../../generic/modals/EntryPalletsModal'
import KnisaCreatePageLayout from './Components/KnisaCreatePageLayout'
import KnisaCreateScrollArea from './Components/KnisaCreateScrollArea'
import KnisaTitleCard from './Components/KnisaTitleCard'
import KnisaActionDock from './Components/KnisaActionDock'
import DetailRow from './Components/DetailRow'
import { SearchInput } from '../../../../../generic/ui/SearchInput'
import KbdChipButton from '../../../../../generic/ui/KbdChipButton/KbdChipButton'
import ConfirmDialog from '../../../../../generic/ui/ConfirmDialog/ConfirmDialog'
import PrintIcon from '../../../../../generic/icons/IconLib/PrintIcon'
import styled from 'styled-components'
import useCreateKnisa from './services/hooks/useCreateKnisa'

export type { IDetailsSelected, IMarketPalletDetailsResponse } from './services/hooks/useCreateKnisa'

const CreateKnisa = () => {
  const c = useCreateKnisa()

  const titleLabel = c.id
    ? c.t('knisa_create_page_title_ids', { id: `#${c.knisaTitleData?.EntryNum}` })
    : c.t('knisa_create_page_title')

  const scrollHeader = c.knisaTitleData ? (
    <KnisaTitleCard data={c.knisaTitleData} onEdit={() => c.handleControlTitle(true)} />
  ) : null

  const stickyHeader = c.knisaTitleData ? (
    <StickyHeaderRow>
      <SearchInput
        value={c.searchDetails}
        onChange={(e) => c.setSearchDetails(e.target.value)}
        placeholder={c.t('knisa_create_page_search_placeholder')}
        // showKbd={false}
      />
      {(c.knisaDetailsData?.length ?? 0) > 0 && (
        <KbdChipButton
          type='button'
          aria-label={c.t('knisa_create_mass_print_title')}
          onClick={c.handleControlMassPrint}
        >
          <PrintIcon />
        </KbdChipButton>
      )}
    </StickyHeaderRow>
  ) : null

  return (
    <KnisaCreatePageLayout title={titleLabel}>
      {c.isAllowToShowTitle && (
        <AppModal
          title={
            c.knisaTitleData
              ? c.t('knisa_create_page_title_ids', { id: `#${c.knisaTitleData.EntryNum}` })
              : c.t('knisa_create_modal_title_title')
          }
          Children={ModalKnisaTitle}
          controlFunc={() => c.handleControlTitle(!!c.knisaTitleData)}
          childrenProps={c.modalProps}
        />
      )}
      {c.isOpenProduct && (
        <AppModal
          title={
            c.selectedItem
              ? c.t('knisa_create_modal_product_title_edit')
              : c.t('knisa_create_modal_product_title_create')
          }
          Children={ModalKnisaAddProduct}
          controlFunc={c.handleControlProduct}
          childrenProps={c.addProductProps}
        />
      )}
      {c.isOpenDivideModal && (
        <AppModal
          title={c.t('knisa_create_divide_modal_title', {
            entry: c.selectedItemForDivide?.EntryNum,
            detail: c.selectedItemForDivide?.DetailNum,
          })}
          Children={DivideModal}
          childrenProps={c.divideModalP}
          controlFunc={c.handleOpenDivideModal}
        />
      )}
      <ConfirmDialog
        open={c.isOpenMassPrint}
        title={c.t('knisa_create_mass_print_title')}
        message={c.t('knisa_create_mass_print_message')}
        confirmLabel={c.t('knisa_create_mass_print_confirm')}
        loadingLabel={c.t('knisa_create_mass_print_printing')}
        confirmVariant='accent'
        isLoading={c.isMassPrinting}
        onCancel={c.handleControlMassPrint}
        onConfirm={c.handleMassPrint}
      />
      {c.isOpenEntryPallets && c.selectedEntryItem && (
        <AppModal
          title={c.t('knisa_create_pallets_modal_title', {
            entry: c.selectedEntryItem.EntryNum,
            detail: c.selectedEntryItem.DetailNum,
          })}
          Children={EntryPalletsModal}
          childrenProps={{ entryItem: c.selectedEntryItem }}
          controlFunc={() => c.setIsOpenEntryPallets(false)}
          size='md'
        />
      )}

      <KnisaCreateScrollArea scrollHeader={scrollHeader} stickyHeader={stickyHeader}>
        {c.knisaDetailsData &&
          c.render.map((d, i) => (
            <DetailRow
              key={d.id ?? `${d.EntryNum}-${d.DetailNum}`}
              {...d}
              item={d}
              isLast={i === c.render.length - 1}
              handleSelectItem={c.detailsProps.handleSelectItem}
              print={c.detailsProps.print}
              selectForDivide={c.detailsProps.selectForDivide}
              handleDeleteItem={c.detailsProps.handleDeleteItem}
              onBadgeClick={c.detailsProps.onBadgeClick}
              isOffice={c.detailsProps.isOffice}
            />
          ))}
      </KnisaCreateScrollArea>

      <KnisaActionDock
        onBack={c.handleBack}
        onCreate={c.handleControlProduct}
        canCreate={c.isOffice && !!c.knisaTitleData}
      />
    </KnisaCreatePageLayout>
  )
}

const StickyHeaderRow = styled.div`
  display: flex;
  align-items: center;
  gap: 0.5rem;
`

export default CreateKnisa
